import { z } from 'zod';

import { schemaBigDecimal } from '../../../../utils/schema.utils';
import { schemaEuropaceAntragstellerzuordnung } from '../../Antragstellerzuordnung.schema';

/*
	https://docs.api.europace.de/privatkredit/vorgaenge/kex-vorgang-import-api/#kreditkarte

	{
		"abloesen": true | false
		"beanspruchterBetrag": schemaBigDecimal,
		"bic": String,
		"gehoertZuAntragsteller": Antragstellerzuordnung,
		"glaeubiger": String,
		"iban": String,
		"kreditinstitut": String,
		"rateMonatlich": schemaBigDecimal,
		"verfuegungsrahmen": schemaBigDecimal,
		"zinssatz": schemaBigDecimal,
	}

*/

export const schemaEuropaceKreditkarte = z.object({
    abloesen: z.optional(z.boolean()),
    beanspruchterBetrag: z.optional(schemaBigDecimal),
    bic: z.optional(z.string()),
    europaceId: z.optional(z.string().min(1)),
    gehoertZuAntragsteller: z.optional(schemaEuropaceAntragstellerzuordnung),
    glaeubiger: z.optional(z.string()),
    iban: z.optional(z.string()),
    id: z.string().min(1),
    kreditinstitut: z.optional(z.string()),
    rateMonatlich: z.optional(schemaBigDecimal),
    verfuegungsrahmen: z.optional(schemaBigDecimal),
    zinssatz: z.optional(schemaBigDecimal),
});

export type SchemaEuropaceKreditkarte = z.infer<typeof schemaEuropaceKreditkarte>;
